<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newVatRate()"
                aria-label="New vat rate" *appIsGranted="['VAT rates', 'CREATE']">
            {{ 'New'|translate }}
        </button>
    </div>
</div>
<!-- / SIDEBAR CONTENT -->
